(() => {
  const offer=document.querySelector('[data-kb-offer]');
  const config=document.getElementById('kb-ui-strings');
  if(!offer||!config)return;
  const ui=JSON.parse(config.textContent);
  const expanded=new Set();
  const sizes=[6,12,18];
  const format=new Intl.NumberFormat(offer.dataset.locale||'de',{style:'currency',currency:offer.dataset.currency||'EUR'});
  const unit=Number(offer.dataset.unitPrice)/100;
  const fill=(text,values)=>Object.entries(values).reduce((s,[k,v])=>s.replaceAll(`{${k}}`,v).replaceAll(`__${k.toUpperCase()}__`,v),text);
  const setText=(node,text)=>{if(node&&node.textContent!==text)node.textContent=text;};
  const motion=matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth';
  const wrapperFor=index=>offer.querySelector(`[data-tier-title="${index}"]`)?.closest('.pumper_template_9_block_wrapper');
  const current=()=>offer.querySelector('.pumper_pair:checked')?.closest('.pumper_template_9_block_wrapper');
  const moneyValue=text=>Number(text.replace(/[^\d,.]/g,'').replace(/\.(?=\d{3}(?:\D|$))/g,'').replace(',','.'));
  const returnToOffer=()=>{const target=offer.querySelector('[data-block-id="buy_buttons"]')||offer;target.scrollIntoView({behavior:motion,block:'start'});const radio=current()?.querySelector('input[type=radio]');if(radio)radio.focus({preventScroll:true});};
  const selectedTriggers=()=>Array.from(current()?.querySelectorAll('.pumper_dropdown_trigger')||[]).filter(e=>e.closest('.pumper_block__cbinfo--item'));
  let observer;
  const refresh=()=>{
    observer?.disconnect();
    for(let index=0;index<3;index++){
      const wrapper=wrapperFor(index);
      if(!wrapper)continue;
      const price=wrapper.querySelector('.tier-price__main');
      const amount=price?moneyValue(price.textContent):NaN;
      const subtitle=wrapper.querySelector('[data-tier-offer-subtitle]');
      const pieces=fill(ui.pots,{count:sizes[index]});
      const details=Number.isFinite(amount)&&amount>0?`${pieces}\n${fill(ui.per_pot,{price:format.format(amount/sizes[index])})}\n${fill(ui.saved,{price:format.format(unit*sizes[index]-amount)})}`:pieces;
      setText(subtitle,details);
      if(Number.isFinite(amount)&&amount>0&&unit>0){
        const percentage=Math.round((1-amount/(unit*sizes[index]))*100);
        setText(wrapper.querySelector('[data-tier-subtitle]'),fill(ui.saving,{percent:percentage}));
      }
      let controls=wrapper.querySelector('.kb-native-controls');
      if(!controls&&wrapper.querySelector('.pumper_block__cbinfo--item')){
        controls=document.createElement('div');controls.className='kb-native-controls';
        const p=document.createElement('p');p.className='kb-native-summary';controls.append(p);
        const button=document.createElement('button');button.type='button';button.className='kb-link-button';button.dataset.kbCustomize=String(index);controls.append(button);
        wrapper.querySelector('label')?.after(controls);
      }
      const isExpanded=expanded.has(index);
      wrapper.classList.toggle('kb-collapsed',!isExpanded);
      if(controls){
        controls.hidden=!wrapper.querySelector('input.pumper_pair:checked');
        // Continue the native card frame without nesting a button in its label.
        const label=wrapper.querySelector('.pumper_template_9_label');
        if(label&&!controls.hidden){
          const frame=getComputedStyle(label);
          const frameStyles={'--kb-card-border-width':frame.borderLeftWidth,'--kb-card-border-color':frame.borderLeftColor,'--kb-card-background':frame.backgroundColor,'--kb-card-padding':frame.paddingLeft};
          for(const [property,value] of Object.entries(frameStyles))if(controls.style.getPropertyValue(property)!==value)controls.style.setProperty(property,value);
        }
        setText(controls.querySelector('p'),fill(ui.summary,{count:sizes[index]}));
        const button=controls.querySelector('button');setText(button,isExpanded?ui.hide:ui.customize);button.setAttribute('aria-expanded',String(isExpanded));
      }
    }
    const buy=offer.querySelector('[data-block-id="buy_buttons"]');
    const heading=buy?.querySelector('#pumper__block_title,h2,h3,[role="heading"]');
    if(heading){heading.classList.add('kb-pumper-title');setText(heading,ui.offer_heading);}
    for(const node of offer.querySelectorAll('.gift-title-text')){
      for(const [property,value] of Object.entries({'white-space':'normal','overflow':'visible','text-overflow':'clip','line-height':'1.4'})){
        if(node.style.getPropertyValue(property)!==value||node.style.getPropertyPriority(property)!=='important')node.style.setProperty(property,value,'important');
      }
      const original=node.dataset.kbOriginal||node.textContent;node.dataset.kbOriginal=original;
      const value=original.toLowerCase();
      if(/charbon|kohle|houtskool/.test(value))setText(node,ui.charcoal);
      else if(/grand format/.test(value))setText(node,ui.burner_large);
      else if(/usb/.test(value)){const tier=node.closest('.pumper_template_9_block_wrapper')?.querySelector('[data-tier-title]')?.dataset.tierTitle;setText(node,tier==='1'?ui.burner_large:ui.burner_usb);}
      else if(/électrique|elektrisch/i.test(value))setText(node,ui.burner_electric);
      else if(/bois|holz|houten/i.test(value))setText(node,ui.burner_wood);
      else if(/brûleur|räuchergefäß|wierookvat|wierookbrander/i.test(value))setText(node,ui.burner);
    }
    for(const node of offer.querySelectorAll('.pumper_free_gift_label,[class*="selected-gift-text"]')){
      if(/^\s*(GRATUIT|FREI|FREE|VRIJ|GRATIS)\s*$/i.test(node.textContent))setText(node,ui.gift_free);
    }
    const textWalker=document.createTreeWalker(offer,NodeFilter.SHOW_TEXT);
    while(textWalker.nextNode()){const node=textWalker.currentNode;if(node.parentElement?.closest('[class*="gift"]')&&/^\s*(FREI|FREE|GRATUIT|VRIJ|GRATIS)\s*$/i.test(node.nodeValue))node.nodeValue=ui.gift_free;}
    const active=current();
    const activeIndex=active?.querySelector('[data-tier-title]')?.dataset.tierTitle;
    const activePrice=active?.querySelector('.tier-price__main')?.textContent.trim();
    const sticky=document.querySelector('sticky-buy-button');
    if(sticky&&activeIndex!==undefined&&activePrice){
      setText(sticky.querySelector('button span'),`${ui.sticky} · ${sizes[Number(activeIndex)]} × 30 g · ${activePrice}`);
      sticky.querySelector('button')?.setAttribute('aria-label',`${ui.sticky} ${activePrice}`);
      if(!sticky.dataset.kbBound){sticky.dataset.kbBound='true';sticky.querySelector('button')?.addEventListener('click',e=>{e.preventDefault();e.stopImmediatePropagation();returnToOffer();},true);}
    }
    observer?.observe(offer,{childList:true,subtree:true,characterData:true});
  };
  let scheduled=false;
  observer=new MutationObserver(()=>{if(!scheduled){scheduled=true;requestAnimationFrame(()=>{scheduled=false;refresh();});}});
  refresh();
  offer.addEventListener('change',event=>{if(event.target.matches('input.pumper_pair'))requestAnimationFrame(refresh);});
  for(const node of document.querySelectorAll('footer p,[class*="footer"] p')){if(/^Karamats (entstand|est n[ée])/i.test(node.textContent.trim()))setText(node,ui.footer_brand);}
  for(const node of document.querySelectorAll('[role="region"],[role="region"] *')){if(node.children.length===0&&/Kostenloser Versand ab|Livraison offerte dès|Gratis verzending vanaf/.test(node.textContent))setText(node,ui.shipping_banner);}
  const status=text=>{const node=document.querySelector('[data-kb-status]');if(node)node.textContent=text;};
  const settle=()=>new Promise(resolve=>requestAnimationFrame(()=>requestAnimationFrame(resolve)));
  const selectSlot=async(index,name)=>{
    const trigger=selectedTriggers()[index];
    if(!trigger)throw Error('Scent slot unavailable');
    if(trigger.getAttribute('aria-expanded')!=='true')trigger.click();
    await settle();
    const group=trigger.closest('.pumper_dropdown_group');
    const options=Array.from(group?.querySelectorAll('[role=option]')||[]);
    const option=options.find(e=>(e.querySelector('[data-pmpr-gt-option]')?.dataset.pmprGtOption||e.textContent).trim().toUpperCase()===name.toUpperCase());
    if(!option||option.getAttribute('aria-disabled')==='true')throw Error('Scent option unavailable');
    option.click();await settle();
    const value=selectedTriggers()[index]?.querySelector('.pumper_dropdown_value')?.textContent.trim();
    if(value?.toUpperCase()!==name.toUpperCase())throw Error('Scent selection not confirmed');
  };
  document.addEventListener('click',async event=>{
    const button=event.target.closest('button');if(!button)return;
    if(button.hasAttribute('data-kb-customize')){
      event.preventDefault();event.stopPropagation();const index=Number(button.dataset.kbCustomize);expanded.has(index)?expanded.delete(index):expanded.add(index);refresh();return;
    }
    if(button.hasAttribute('data-kb-family')){
      const family=button.dataset.kbFamily;
      document.querySelectorAll('[data-kb-family]').forEach(e=>e.setAttribute('aria-pressed',String(e.dataset.kbFamily===family)));
      document.querySelectorAll('[data-kb-scent-family]').forEach(e=>e.hidden=family!=='all'&&e.dataset.kbScentFamily!==family);
      const catalog=document.querySelector('.kb-catalog');if(catalog)catalog.open=true;
      document.getElementById('kb-scent-list')?.scrollIntoView({behavior:motion,block:'center'});return;
    }
    if(button.hasAttribute('data-kb-return')){returnToOffer();return;}
    if(button.hasAttribute('data-kb-box')){wrapperFor(Number(button.dataset.kbBox))?.querySelector('input[type=radio]')?.click();await settle();refresh();returnToOffer();return;}
    if(button.hasAttribute('data-kb-preset')||button.hasAttribute('data-kb-first-scent')){
      button.disabled=true;status(ui.working);
      try{
        if(button.hasAttribute('data-kb-preset')){
          wrapperFor(0)?.querySelector('input[type=radio]')?.click();await settle();expanded.add(0);refresh();
          const names=offer.dataset.locale==='nl'?['OUD MALAKI','MUSK & AMBER','SABAYA','Sandelhout','ANBARI','MUSK ROOS & OUD']:offer.dataset.locale==='fr'?['OUD MALAKI','MUSK & AMBRE','SABAYA','SANDALWOOD','ANBARI','MUSK ROSE & OUD']:['OUD MALAKI','MOSCHUS & AMBRA','SABAYA','Sandelholz','ANBARI','MOSCHUSROSE & OUD'];
          for(let i=0;i<names.length;i++)await selectSlot(i,names[i]);
          status(ui.preset_success);
        }else{
          const index=Number(current()?.querySelector('[data-tier-title]')?.dataset.tierTitle||0);expanded.add(index);refresh();
          await selectSlot(0,button.dataset.kbFirstScent);status(ui.selection_success);
        }
      }catch(error){status(ui.preset_error);}
      finally{button.disabled=false;refresh();returnToOffer();}
    }
  });
})();
